import { Component } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
  constructor() { }
}





// WEBPACK FOOTER //
// C:/Users/Alec/Documents/dev/recog/recog/src/app/shared-module/widgets/loading/loading.component.ts